export const menu = {
  enableInsights: false,
  groups: [
    {
      name: 'Cadastros',
      modules: [
        {
          path: 'query',
          label: 'Dialetos',
          icon: 'convert_to_text',
          roles: ['dialect-query-listar'],
        },
      ],
    },
    {
      name: 'Operacional',
      modules: [
        {
          path: 'busca',
          label: 'Simular Busca',
          icon: 'search',
          roles: ['dialect-query-listar'],
        },
        {
          path: 'monitoramento',
          label: 'Buscas & Resultados',
          icon: 'monitoring',
          roles: ['dialect-query-listar'],
        },
      ],
    },
  ],
};
